import React from 'react';

interface IFomo {
  highlight_subtitle: string;
  highlight_subtitle_second_line: string;
}
interface ILeadFormRibbon {
  fomo: IFomo;
}

const LeadFormRibbon = (props: ILeadFormRibbon) => {
  const { fomo } = props;

  return (
    <div className="absolute h-40 top-0 right-0 px-1 py-4 font-bold overflow-hidden h-36 w-auto">
      <div className="bg-lp-yellow transform rotate-45 px-14 py-1 relative top-4 left-16">
        <div className="text-sm text-brand-secondary-color text-center">
          {fomo?.highlight_subtitle}
        </div>
        <div className="text-md text-brand-primary-color text-center">
          {fomo?.highlight_subtitle_second_line}
        </div>
      </div>
    </div>
  );
};

export default LeadFormRibbon;
